import {
  Autocomplete,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
} from "@mui/material";
import {
  DataGrid,
  GridActionsCellItem,
  GridColumns,
  GridRowId,
} from "@mui/x-data-grid";
import React, { useState, useEffect } from "react";
import { FaTrash } from "react-icons/fa";
import {
  getMeasureInChargeInstitutions,
  getPointers,
  insertPointer,
  removePointer,
} from "../../../../server/server";
import { useSearchParams } from "react-router-dom";
import { getAllInstitutions } from "../../../../server/server";
import { notif } from "../../../utils/util";
import ConfirmationModal from "../../../modals/ConfirmationModal";

function PointerMeasure({ disabled }: any) {
  const [searchParams] = useSearchParams();
  const [title, setTitle] = useState("");
  const [items, setItems] = useState<any>([]);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(6);
  const [rowCountState, setRowCountState] = useState(6);
  const [isLoading, setIsLoading] = useState(true);
  const [editID, setEditID] = useState("");
  const [institutions, setInstitutions] = useState<any>([]);
  const [insitutionType, setInstitutionType] = useState("");
  const [defaultInstitution, setDefaultInstitution] = useState<any>();
  const [deadline, setDeadline] = useState("");
  const [comment, setComment] = useState("");
  const [selectedOption, setSelectedOption] = useState(0);
  const [deleteModalIsOpen, setDeleteModalIsOpen] = useState(false);
  const [deleteId, setDeleteId] = useState<any>();
  const handleAdd = () => {};

  const loadPointers = async (offset: any = 0, id: any = editID) => {
    const resp = await getPointers(id);
    if (resp?.status === 200) {
      setItems(resp?.data);
      setIsLoading(false);
    }
  };

  const setPageAndCall = (page: any) => {
    setPage(page);
  };

  const insertNew = async () => {
    const resp = await insertPointer({
      text: title,
      measure: editID,
      deadline,
      institution: defaultInstitution?.id || "",
      comment,
      status: selectedOption?.toString(),
    });

    if (resp?.status === 201) {
      setTitle("");
      setDefaultInstitution({});
      setInstitutionType("");
      setDeadline("");
      setComment("");
      setSelectedOption(0);
      loadPointers();
    }
  };
  const loadAllInstitutions = async () => {
    const resp = await getAllInstitutions();
    if (resp?.status === 200) {
      setInstitutions(resp?.data);
    }
  };
  const deletePointer = () => {
    delPointer();
    setDeleteModalIsOpen(false);
  };
  const delPointer = async () => {
    const resp = await removePointer(deleteId);
    if (resp.status === 200) {
      notif("Показатељ успешно обрисан", "success");
      setItems((prevRows: any) =>
        prevRows.filter((row: any) => row.id !== deleteId),
      );
    } else {
      notif("Показатељ није обрисан", "error");
    }
  };
  const deleteItem = React.useCallback(
    (id: GridRowId) => () => {
      setTimeout(() => {
        setDeleteModalIsOpen(true);
        setDeleteId(id);
      });
    },
    [],
  );
  const columns = React.useMemo<GridColumns<any>>(
    () => [
      {
        field: "text",
        headerName: "Показатељ",
        flex: 1,
      },
      {
        field: "actions",
        type: "actions",
        width: 60,
        getActions: (params: any) => [
          <GridActionsCellItem
            icon={<FaTrash style={{ width: 20, height: 20 }} />}
            sx={{ width: 50, height: 50 }}
            label="Обриши"
            onClick={deleteItem(params.id)}
            disabled={disabled}
          />,
        ],
      },
    ],
    [deleteItem],
  );
  useEffect(() => {
    loadAllInstitutions();
    let eId = searchParams.get("id");
    if (eId) {
      loadPointers(0, eId);
      setEditID(eId);
    }
  }, []);

  const closeDeleteModal = () => {
    setDeleteModalIsOpen(false);
  };

  const addButtonDisabled = title.trim() === "";
  return (
    <div>
      <div className="flex items-center gap-4">
        {" "}
        <div className="flex flex-col items-start gap-3">
          <p className="w-[260px]">Показатељ</p>
          <TextField
            disabled={disabled}
            label="Показатељ"
            id="outlined-size-small"
            type="institutionName"
            name="institutionName"
            size="small"
            multiline
            sx={{ width: 300 }}
            value={title}
            onChange={(e) => setTitle(e.target.value)}
          />
        </div>
      </div>

      <div className="w-full flex justify-end mt-6 items-center">
        <Button
          disabled={disabled || addButtonDisabled}
          variant="contained"
          sx={{ backgroundColor: "#0F2765" }}
          onClick={insertNew}
        >
          Потврди
        </Button>
      </div>
      <div className="mt-5 h-[430px] w-full">
        <DataGrid
          rowCount={rowCountState}
          loading={isLoading}
          pagination
          disableColumnMenu
          paginationMode="server"
          onPageChange={(newPage) => setPageAndCall(newPage)}
          onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
          page={page}
          pageSize={pageSize}
          rows={items}
          getRowHeight={() => "auto"}
          columns={columns}
          style={{ zIndex: 0 }}
          rowsPerPageOptions={[5]}
          disableSelectionOnClick
          components={{
            NoRowsOverlay: () => (
              <Stack height="100%" alignItems="center" justifyContent="center">
                Не постоје показатељи
              </Stack>
            ),
            NoResultsOverlay: () => (
              <Stack height="100%" alignItems="center" justifyContent="center">
                Не постоје показатељи
              </Stack>
            ),
          }}
        />
      </div>
      <ConfirmationModal
        modalIsOpen={deleteModalIsOpen}
        closeModal={closeDeleteModal}
        confirmation={deletePointer}
        message={`Обриши  показатељ?`}
      />
    </div>
  );
}

export default PointerMeasure;
